// @flow

import Ajv from "ajv";
import HierarchyAssignmentSchema from "../components/hierarchy-scope/schema";
import { removeNullAndUndefinedProps } from "@transformers/object";

export * from "./service-settings";
export * from "./email-notifications";
export * from "./manager-sms-notifications";
export * from "./employee-sms-notifications";
export * from "./shift-patterns";
export * from "./nurse-declined-reasons";
export * from "./absence-reasons";
export * from "./wellbeing-services";
export * from "./employee-identity";
export * from "./standard-questions";
export * from "./dynamic-questions";
export * from "./special-contacts";
export * from "./special-contacts-types";
export * from "./email-controls";
export * from "./system-access";
export * from "./default-standard-scripts";
export * from "./staff-groups";
export * from "./alerts";
export * from "./referrals";
export * from "./rtw";
export * from "./absence-monitoring";
export * from "./user-accounts";
export * from "./app-adoption";
export * from "./pages";
export * from "./manager-self-service";
export * from "./audit-logs";

export const isLoading = (state: Object) => {
  const service = state.service;
  for (const prop in service) {
    if (service[prop].requestsInProgress > 0) return true;
  }
  return false;
};

export const getError = (state: Object) => state.service.error;
export const getSuccessMessage = (state: Object) => state.clients.success;

export const validateHierarchyAssignmentSchema = assignments => {
  const validate = new Ajv().compile(HierarchyAssignmentSchema);
  let invalidAssignments = 0;

  // Validation should triggered against every assignment separately
  // generate invalid assignments counter that prevents trigger save
  assignments &&
    assignments.map(a => {
      const valid = validate(removeNullAndUndefinedProps(a));
      if (!valid) {
        invalidAssignments++;
      }
    });

  return invalidAssignments === 0;
};
